import apiEndPoints from "../../apiconstants";
import { api, handleErrorResponse } from "../api"
import { DashboardAPIData, DashboardAPIResponse } from "./dashboardtypes";

export interface EngagementFlagPercentage {
  less_engaged: number;
  high_engaged: number;
}

interface GetTotalConversationsResponse {
  engagement_flag_percentage: EngagementFlagPercentage;
  total_conversations: number;
}

interface dashbaordAPIPayload {
  filters: {
    advisor_id: string;
  }
}

// Define a service using a base URL and expected endpoints
export const dashboardApiSlice = api.injectEndpoints({
  endpoints: builder => ({
    getTotalConversations: builder.query<GetTotalConversationsResponse, void>({
      query: () => apiEndPoints?.getTotalConversations,
      transformResponse: (response: any) => response.data,
      transformErrorResponse: handleErrorResponse,
      providesTags: (result, error, id) => [{ type: "Dashboard", id: String(id) }],
    }),
    getDashboardData: builder.mutation<any, { advisorID?: string }>({
      query: (payLoad) => ({
        url: payLoad.advisorID
          ? `${apiEndPoints?.getDashboardConversations}/${payLoad.advisorID}`
          : apiEndPoints?.getDashboardConversations,
        method: 'GET',
        body: payLoad
      }),
      transformResponse: (response: any) => response.data,
      transformErrorResponse: handleErrorResponse
    }),
    getUserOrgs: builder.query<any, string>({
      query: (user_id) => `${apiEndPoints?.getUserOrganisations}/${user_id}/organizations`,
      transformResponse: (response: any) => response.data,
      transformErrorResponse: handleErrorResponse,
    }),
    fetchDashboardConversationDetails: builder.mutation<any, { advisorID?: string }>({
      query: ({ advisorID }) => ({
        url: advisorID
          ? `${apiEndPoints?.getDashboardConversations}/${advisorID}`
          : apiEndPoints?.getDashboardConversations,
        method: 'GET',
      }),
      transformResponse: (response: any) => response.data,
      transformErrorResponse: handleErrorResponse
    }),
  })
})

// Hooks are auto-generated by RTK-Query
// Same as `advisorApiSlice.endpoints.getQuotes.useQuery`
export const { useGetTotalConversationsQuery, useGetDashboardDataMutation, useGetUserOrgsQuery, useFetchDashboardConversationDetailsMutation } = dashboardApiSlice